import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import MainLayout from "@/layouts/MainLayout/MainLayout.vue";
import DetailsView from "@/views/DetailsView/DetailsView.vue";
import ReferralView from "@/views/DetailsView/ReferralView/ReferralView.vue";
import DepositsView from "@/views/DetailsView/DepositsView/DepositsView.vue";
import WithdrawalsView from "@/views/DetailsView/WithdrawalsView/WithdrawalsView.vue";
import HomeView from "@/views/HomeView/HomeView.vue";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import SocialMediaView from "@/views/SocialMediaView/SocialMediaView.vue";
import FaqView from "@/views/FaqView/FaqView.vue";
import NotificationsView from "@/views/NotificationsView/NotificationsView.vue";
import SettingsView from "@/views/SettingsView/SettingsView.vue";
import TopUpView from "@/views/TopUpView/TopUpView.vue";
import WithdrawalView from "@/views/WithdrawalView/WithdrawalView.vue";
import AnalyticView from "@/views/AnalyticView/AnalyticView.vue";
import FaqCategoryView from "@/views/FaqView/FaqCategoryView/FaqCategoryView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: MainLayout,
    children : [
      {
        path : '',
        component : HomeView
      },
      {
        path : 'analytic',
        component : AnalyticView
      },
      {
        path : 'wallet',
        component : DetailsView,
        redirect : '/wallet/deposits',
        children: [
          {
            path : 'referrals',
            component : ReferralView
          },
          {
            path : 'deposits',
            component : DepositsView
          },
          {
            path : 'withdrawals',
            component : WithdrawalsView
          }
        ]
      }
    ]
  },
  {
    path : '/wallet/top-up',
    component : TopUpView
  },
  {
    path : '/wallet/withdrawal',
    component : WithdrawalView
  },
  {
    path : '/settings',
    component : SettingsView,
  },
  {
    path : '/social',
    component : SocialMediaView
  },
  {
    path : '/faq',
    component : FaqView
  },
  {
    path : '/faq/:group',
    component : FaqCategoryView
  },
  {
    path : '/notifications',
    component : NotificationsView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
